import { useNav } from '../state/NavContext';
import { useProfile } from '../state/ProfileContext';
import { useSettings } from '../state/SettingsContext';
import { plantGrowth } from '../state/plantGrowth';
import { Vine } from './Vine';

export function PlantProgress({ streak, compact = false, scope, customize = true }: {
  streak: number; compact?: boolean; scope?: string; customize?: boolean;
}) {
  const { profile } = useProfile();
  const { effectiveReducedMotion } = useSettings();
  const { navigate } = useNav();
  const avatar = profile?.avatar ?? 'sprout';
  const growth = plantGrowth(avatar, streak);

  return (
    <section className={`cv-plant-progress${compact ? ' cv-plant-progress--compact' : ''}`} aria-label="Your growing plant">
      <div className="cv-plant-progress__art">
        <Vine streak={streak} avatar={avatar} reducedMotion={effectiveReducedMotion} />
      </div>
      <div className="cv-plant-progress__story">
        <h2>{profile?.name ? `${profile.name}’s` : 'Your'} {growth.name.toLowerCase()}</h2>
        <p className="cv-plant-progress__stage">{growth.stage} · {growth.days}-day{scope ? ` ${scope}` : ''} streak</p>
        {!compact ? <p className="cv-help">{growth.description} {scope ? `Win the ${scope} daily to keep it growing.` : 'Growth follows your longest active daily streak.'}</p> : null}
        <div className="cv-plant-progress__milestone">
          <div className="cv-plant-progress__track" role="progressbar" aria-label="Next streak milestone" aria-valuemin={0} aria-valuemax={growth.next} aria-valuenow={growth.days}>
            <span style={{ width: `${growth.days / growth.next * 100}%` }} />
          </div>
          <p className="cv-help">{growth.days === 0 ? 'Win a daily to begin growing.' : `${growth.next - growth.days} more ${growth.next - growth.days === 1 ? 'day' : 'days'} to your ${growth.next}-day milestone`}</p>
        </div>
        {customize ? <button className="cv-plant-progress__change" type="button" onClick={() => navigate('settings')}>Change your plant</button> : null}
      </div>
    </section>
  );
}
